import { Editor } from 'ckeditor5';
import { QualioAttachmentCKUploadAdapter } from '../shared/CKEditor/plugins/Attachment/QualioAttachmentCKUploadAdapter';
import { configureAnalytics } from '../shared/CKEditor/util/Analytics/AnaylyticsUtils';
import { ToolbarManager } from '../shared/CKEditor/util/ToolbarManager';
import { setUpScrollHandler } from '../../utils/scrollHandler';

const configureUploadAdapter = (editor: Editor) => {
  const fileRepositoryPlugin = editor.plugins.get('FileRepository');
  fileRepositoryPlugin.createUploadAdapter = (loader: any) => {
    return new QualioAttachmentCKUploadAdapter(loader);
  };
};

export const setupClickListener = (editor: Editor): void => {
  editor.editing.view.listenTo(editor.editing.view.document, 'click', (evt: any, data: any) => {
    const clickedElement = data.domTarget as HTMLElement;
    const href = clickedElement.getAttribute('href');
    // always open smart links in new tab
    if (clickedElement.dataset.mention && href) {
      globalThis.open(href, '_blank');
    }
  });
};

function mathCharactersExtended(editor: Editor): void {
  const scp = editor.plugins.get('SpecialCharacters');
  scp.addItems('Mathematical', [{ title: 'delta', character: 'Δ' }]);
}

export const createEditorReadyHandler =
  (toolbarManager: ToolbarManager, pageHeaderSectionIndex: string) =>
  (editor: Editor): void => {
    const scrollHandler = () => {
      editor.focus();
    };
    setUpScrollHandler(scrollHandler);
    setupClickListener(editor);
    mathCharactersExtended(editor);
    toolbarManager.setToolbarToParentFromEditor(editor, pageHeaderSectionIndex);
    configureUploadAdapter(editor);
    editor.model.schema.setAttributeProperties('htmlAttributes', {
      isFormatting: true,
    });
    configureAnalytics(editor, analytics);
  };
